import type { SliceRouteContract } from '@/shared/lib/vsa';

import { DesignShowcasePage } from './DesignShowcasePage';

export const designShowcaseRouteContract: SliceRouteContract = {
  routeId: 'design',
  component: DesignShowcasePage,
};
